"use strict";
import { useIsDarkMode } from "theme/components/ThemeToggle";
const ASPECT_RATIO = 3.6354;
export function TopazWordmark({ height = 28 }) {
  const isDark = useIsDarkMode();
  const variant = isDark ? "white" : "dark";
  const width = Math.round(height * ASPECT_RATIO);
  return <picture>
      <source srcSet={`/brand/topaz-wordmark-${variant}.webp`} type="image/webp" />
      <img
    src={`/brand/topaz-wordmark-${variant}.png`}
    alt="Topaz Dex"
    width={width}
    height={height}
    style={{ display: "block", height, width, objectFit: "contain" }}
    draggable={false}
  />
    </picture>;
}
